import { render, staticRenderFns } from "./JdGoods.vue?vue&type=template&id=5aa25d78&scoped=true"
import script from "./JdGoods.vue?vue&type=script&lang=js"
export * from "./JdGoods.vue?vue&type=script&lang=js"
import style0 from "./JdGoods.vue?vue&type=style&index=0&id=5aa25d78&prod&lang=css"
import style1 from "./JdGoods.vue?vue&type=style&index=1&id=5aa25d78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa25d78",
  null
  
)

export default component.exports